import type { AxiosRequestConfig } from "axios";

import { QueryClient } from "@citrine/client";

import type { TeamMember } from "./team-member";

export class TeamMemberClient extends QueryClient<TeamMember> {
  protected constructor(protected teamId: string | undefined) {
    super({
      endpoint: `/api/v3/teams/${teamId}/users`,
      getField: "user",
      findField: "users",
    });
  }

  static getInstance(teamId: string | undefined) {
    return new this(teamId);
  }

  createConfig(teamMember: TeamMember): AxiosRequestConfig {
    return {
      method: "PUT",
      url: this.endpoint,
      data: teamMember,
    };
  }

  deleteConfig(id: string): AxiosRequestConfig {
    return {
      method: "POST",
      url: `${this.endpoint}/batch-remove`,
      data: { ids: [id] },
    };
  }

  updateConfig(teamMember: TeamMember): AxiosRequestConfig {
    return this.createConfig(teamMember);
  }

  protected isEnabled() {
    return Boolean(this.teamId);
  }
}
